import React from 'react';
import {injectIntl, intlShape} from 'react-intl';
import NewConversationBody from './NewConversationBody';
import ContactsList from './ContactsList';
import {NEW_CONVERSATION_FORM_STATE} from './constants';


class NewConversation extends React.Component {
  
  render(){
    return(
      <div>
        {this.renderAccordingToContainerState()}
      </div>
    );
  }

  renderAccordingToContainerState(){
    let elementToRender;
    switch(this.props.viewState){
      case NEW_CONVERSATION_FORM_STATE.BODY_DEFINITION:
        elementToRender = this.renderBodyDefinition();
        break;
      case NEW_CONVERSATION_FORM_STATE.PARTICIPANT_SELECTION:
      default: 
        elementToRender = this.renderParticipantSelection();
        break;
    }
    return( 
      <div>
        {elementToRender}
      </div>
    );
  }

  renderParticipantSelection(){
    return(
      <ContactsList
        onContactClick={this.props.onAddParticipantClick}
        showNewGroupBtn={true}
      />
    );
  }

  renderBodyDefinition(){
    return(
      <NewConversationBody
        onSubmit={this.props.onBodySubmit}
      />
    );
  }

}

export default injectIntl(NewConversation);